import React from 'react';
import { Card, CardHeader, CardMedia, CardContent, Typography, CardActions, IconButton } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import { useTranslation } from 'react-i18next';

import defaultProfilePicture from "../../../Assets/defaultProfilePicture.jpg";
import defaultAccommodationPicture from "../../../Assets/defaultAccommodationPicture.png";

const CardComponent = ({ listing, state, setFlyToLocation, navigate }) => {
    const { i18n } = useTranslation();
    const defaultImage = (listing.key === 'Szallas' || listing.isMarketplace) ? defaultAccommodationPicture : defaultProfilePicture;
    return (
    <Card key={listing.id} sx={{ margin: "0.5rem", border: '1px solid black', position: 'relative', 
    boxSizing: 'border-box' }}>
      {/* Card content */}
      <CardHeader            
        action={
          <IconButton
              aria-label="settings"
              onClick={() => {
                if (state.mapInstance) {
                  state.mapInstance.flyTo([listing.latitude, listing.longitude], 18);
                } else {                        
                  setFlyToLocation([listing.latitude, listing.longitude]);
                }
              }}
            >
            <RoomIcon />
          </IconButton>
        } 
        title={listing.title}              
      />
      <CardMedia
        sx={{
                objectFit: "cover", height: 200, width: "100%",
                cursor: 'pointer'}}
                component="img"                      
                image={listing.picture1 || defaultImage}
                alt={listing.title || 'Accommodation'}
                onClick={() => {
                  if (listing.isMarketplace) {
                    navigate(`/${i18n.language}/marketplace-accommodation/${listing.id}`);
                  } else if (listing.key === 'Auto') {
                    navigate(`/${i18n.language}/car/${listing.id}`);
                  } else if (listing.key === 'Property') {
                    navigate(`/${i18n.language}/property/${listing.id}`);
                  } else {
                    navigate(`/${i18n.language}/terkep/${listing.id}`);
                  }
                }}
      />
      <CardContent>
        <Typography variant="body2" >
          {listing.description ? (listing.description.substring(0, 200) + (listing.description.length > 200 ? '...' : '')) : ''}
        </Typography>
      </CardContent>

      {listing.key === 'Auto' ? (
        <Typography sx={{position: 'absolute',
                          backgroundColor: "rgba(0, 128, 0, 0.7)",
                          zIndex: "1000",
                          color: 'white',
                          top: '160px',
                          left: '20px',
                          padding: '5px'
      }}>Irányár: {(listing.price || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} {listing.currency || 'RON'}</Typography>
      ) : listing.property_status === "Sale" ? (
        <Typography sx={{position: 'absolute',
                          backgroundColor: "rgba(0, 128, 0, 0.7)",
                          zIndex: "1000",
                          color: 'white',
                          top: '160px',
                          left: '20px',
                          padding: '5px'
      }}>{listing.listing_type || 'Eladó'}: {(listing.price || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} RON</Typography>
      ) : (
        <Typography sx={{position: 'absolute',
                      backgroundColor: "rgba(0, 128, 0, 0.7)",
                      zIndex: "1000",
                      color: 'white',
                      top: '160px',
                      left: '20px',
                      padding: '5px'
      }}>{listing.listing_type || 'Kiadó'}: {(listing.price || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} RON / {listing.rental_frequency || listing.rental_frquency}</Typography>
      )
      }
      <CardActions disableSpacing>
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 'bold', color: 'text.secondary' }}>
          {listing.seller_username || listing.seller_company_name}
        </Typography>                    
      </CardActions>
    </Card>
    );
};

export default CardComponent;